import React from 'react';
import Hotitemcard from './Hotitemcard';
import '../../styles/HotAccessories.css';

const Home = ({hotAccessoriesCover,hotAccessories}) => {
    console.log("Home",hotAccessoriesCover['home']);
    console.log("Home data",hotAccessories['home']);
    return (
        <>
        <div className="HotAccessories">
                <div>
                    <img src={hotAccessoriesCover['home']} alt={`${'index'} offer`}></img>
                </div>    

                <div>
                  {
                      hotAccessories['home'].map((item,index)=>{
                          return(
                              <Hotitemcard key={item.image} name={item.name} prize={item.price} image={item.image} index={index}></Hotitemcard>
                          )
                      })
                  }
                </div>

           </div>
        </>
    )
}

export default Home
